import {Outlet} from 'react-router-dom';
import React from "react";

import Onboarding from "../pages/Onboarding";
import PostHogProvider from "../utility/PostHog";


// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    return (
        <PostHogProvider>
            <Onboarding>
                <Outlet/>
            </Onboarding>
        </PostHogProvider>
    );
};

export default MainLayout;
